import { Component, OnInit } from '@angular/core';
import { Message, SelectItem } from 'primeng/components/common/api';
import { GenericComponent } from '../../../../layouts/custom-component/generic-component';
import { UtenteService } from '../_service/UtenteService';
import { Utente } from '../_model/Utente';
import { TestService } from '../_service/TestService';
import { FormBuilder } from '@angular/forms';
import { Utils } from '../../../../../utils';
import { LogService } from '../_service/LogService';
import { Utente_testService } from '../_service/Utente_testService';

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-wrapper",
    templateUrl: 'report.component.html',
    providers: [TestService, LogService, Utente_testService]
})
export class ReportComponent extends GenericComponent {

    elencoTest: SelectItem[];
    testSelezionato: any = null;
    utentiSelezionati: SelectItem[];
    elencoUtenti: SelectItem[];

    constructor(private fb: FormBuilder, private ts: TestService, private ls: LogService, private uts: Utente_testService) {
        super(ts);
    }

    ngOnInit() {

        this.blockedUI = true;
        this.ts.getAll().then((retdata) => {

            this.blockedUI = false;

            if (retdata.response == 0) {

                this.elencoTest = [{ label: "Scegli un test...", value: null }];
                retdata.data.testList.forEach(test => {
                    this.elencoTest.push({ label: test.nome, value: test.id });
                });


            } else {
                this.showMessageError(retdata);
            }
        });



    }



    testChanged() {
        this.utentiSelezionati = [];
        this.elencoUtenti = [];

        this.blockedUI = true;
        this.uts.getAllByTest(this.testSelezionato).then((retdata) => {

            this.blockedUI = false;

            if (retdata.response == 0) {


                retdata.data.utente_testList.forEach(utente => {
                    Utils.log(utente);
                    this.elencoUtenti.push({ label: utente.nome + " " + utente.cognome + " (" + utente.data_inizio + " | " + utente.data_fine + ")", value: utente.id });
                });


            } else {
                this.showMessageError(retdata);
            }

        })
    }


    downloadFile() {
        this.blockedUI = true;

        let params = {
            id: this.testSelezionato,
            utenti: this.utentiSelezionati
        };

        this.ls.downloadFile(params).then((retdata) => {

            let that = this;
            let file = new Blob([(retdata)], { type: 'application/vnd.ms-excel' });

            that.blockedUI = false;
            Utils.openDownloadFile(null, file, 'application/vnd.ms-excel', "report_test_" + this.testSelezionato + ".xlsx", false);

        })
    }



}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/home/report.component.ts